import { Component } from "@angular/core";
import { CommonService } from "../services/common.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-applicant-dashboard",
  templateUrl: "./applicant-dashboard.component.html",
  styleUrls: ["./applicant-dashboard.component.css"],
})
export class ApplicantDashboardComponent {
  myApplicationData: Array<any> = [];
  shortCourseData: Array<any> = [];
  currentDate: Date = new Date();
  userDetails: any;
  url: string = environment.videoUrl;
  table: Array<any> = [];
  showActionColumn = false;
  userName: any = localStorage.getItem("Username");
  resumeShortCourse: any;
  constructor(
    private CommonService: CommonService,
    private toastr: ToastrService
  ) {
    this.get();
    this.getUserProfile();
    // this.getList();
    this.getListForShortCourse();
  }
  get() {
    this.CommonService.postCall("Registration/ApplicationView", {
      USER_ID: localStorage.getItem("UserId"),
    }).subscribe((res: any) => {
      this.myApplicationData = res;
    });
  }
  getUserProfile() {
    this.CommonService.postCall("Registration/GetAudioPath", {
      USERID: localStorage.getItem("UserId"),
      COURSE_ID: localStorage.getItem("CourseId"),
    }).subscribe((res: any) => {
      this.userDetails = res;
    });
  }
  getList() {
    this.CommonService.activateSpinner();
    this.table = [];
    this.CommonService.postCall("Registration/GetShortCoursesByUser", {
      SHORTCOURSE_USERID: localStorage.getItem("UserId"),
      TNT_CODE: localStorage.getItem("TenantCode"),
    }).subscribe(
      (res: any) => {
        this.table = res;
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
      }
    );
  }
  downloadForm() {
    this.CommonService.activateSpinner();
    let payload = {
      USERID: localStorage.getItem("UserId"),
      file_name: "AdmissionLetter.jrxml",
      file_type: "pdf",
      token: localStorage.getItem("tkn"),
      COURSE_ID: localStorage.getItem("CourseId"),
    };

    this.CommonService.reportAPi(payload).subscribe(
      (res: any) => {
        if (res.data.viewPath == null) {
          this.toastr.warning("Admission Letter Not Found");
        } else {
          const urlSegments = res.data.viewPath.split("/");
          const fileName = urlSegments[urlSegments.length - 1];
          const a = document.createElement("a");
          a.href = environment.downloadReportUrl + fileName;
          a.download = "Application Form.pdf"; // Specify the desired file name
          a.style.display = "none"; // Hide the anchor element
          document.body.appendChild(a); // Append to the DOM
          a.click(); // Trigger the download
          document.body.removeChild(a);
        }

        this.CommonService.deactivateSpinner();
      },
      (err: any) => {
        this.CommonService.deactivateSpinner();
      }
    );
  }
  storeProgramId() {
    localStorage.setItem("cID", this.myApplicationData[0]?.course_id);
    localStorage.setItem("cName", this.myApplicationData[0]?.course_name);
  }
  storeShortCourseProgramId() {
    localStorage.setItem("courseFee", this.resumeShortCourse?.COURSE_FEES);
    localStorage.setItem("cID", this.resumeShortCourse?.SHORTCOURSE_ID);
  }
  isSubmitDisabled(is_submit: number): boolean {
    // Disable if is_submit is 0, 1, 2, 3, 4, or 6
    return [0, 1, 2, 3, 4, 6].includes(is_submit);
  }
  getListForShortCourse() {
    this.CommonService.activateSpinner();
    this.shortCourseData = [];
    this.table = [];
    this.CommonService.postCall("Registration/GetShortCoursesByUser", {
      SHORTCOURSE_USERID: localStorage.getItem("UserId"),
      TNT_CODE: localStorage.getItem("TenantCode"),
    }).subscribe(
      (res: any) => {
        this.shortCourseData = res;
        this.resumeShortCourse = res.find((e) => e.SHORTCOURSE_ISSUBMIT == 0);
        this.table = res;
        this.showActionColumn = this.table.some(
          (item) => item.SHORTCOURSE_ISSUBMIT == 0
        );
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
      }
    );
  }
}
